import * as React from "react"

/**
 * Modifies children to forward overrides of design components to their childern.
 * _overrideForwardingDescription is created by FrameNode and contains all the values of forwarded overrides
 * They are extracted here and passed into _forwardedOverrides of the children, or added to an already existing _forwardedOverrides prop
 */
export function processOverrideForwarding(props: any, children?: React.ReactNode): React.ReactNode | undefined {
    if (!children) {
        children = props.children
        if (!children) return children
    }

    let _forwardedOverrides: { [key: string]: any } | undefined = props._forwardedOverrides
    const extractions = props._overrideForwardingDescription
    if (extractions) {
        let added = false
        _forwardedOverrides = {}
        for (const key in extractions) {
            added = true
            _forwardedOverrides[key] = props[extractions[key]]
        }
        if (!added) {
            _forwardedOverrides = undefined
        }
    }

    if (!_forwardedOverrides) return children

    return React.Children.map(children, (child: React.ReactNode) => {
        return React.cloneElement(child as any, { _forwardedOverrides })
    })
}
